export const CONTAINER_TYPE = {
    row: 'VERTICAL_FLOW',
    column: 'HORIZONTAL_FLOW',
};

export const PAGE_ELEMENTS = {
    row_container: 'rows',
    column_container: 'columns',
};
